module.exports = __webpack_public_path__ + "static/img/20180414165827.5ff2d871.jpg";